import setRef from './set-ref';

export default setRef;
